import script from "./FormCadastroEncontro.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCadastroEncontro.vue?vue&type=script&setup=true&lang=js"

import "./FormCadastroEncontro.vue?vue&type=style&index=0&id=28dd9579&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28dd9579"]])

export default __exports__